import isMobile from './is-mobile.js';

//グローバルナビ メガメニュー
$('.js-megamenu .megamenu-wrapper').on({
  'touchstart mouseenter': function touchstartMouseenter() {
    if(!isMobile(1194)){
      $(this).addClass('is-megaMenu--show');
      $("body").addClass('is-megaMenu--showPage');
      $(this).next().find(".megamenu-content").addClass("is-z-index");
      $(this).prev().find(".megamenu-content").addClass("is-z-index");
    }
  },
  'touchend mouseleave': function touchendMouseleave() {
    if(!isMobile(1194)){
      $(this).removeClass('is-megaMenu--show');
      $("body").removeClass('is-megaMenu--showPage');
      $(this).next().find(".megamenu-content").removeClass("is-z-index");
      $(this).prev().find(".megamenu-content").removeClass("is-z-index");
    }
  }
});
//グローバルナビ メガメニュー スマホで親をタップしてもリンクしない
$('.js-megamenu .megamenu-wrapper').on("click", function(e){
  if(isMobile(1194)){
    // if($(e.target).closest("a").is(".megamenu-main-link")) {
    //   $(this).toggleClass('is-megaMenu--show');
    // }
    // return ! $(e.target).closest("a").is(".megamenu-main-link")
  }
})

//ヘッダーが固定でない場合
let megamenu_pos = 100;
$(window).on('scroll', function(){
  let scroll_top = $(window).scrollTop();
  $('.megamenu-content').css({
    'top': megamenu_pos - scroll_top + "px"
  })
  // if(scroll_top == 0) {
  //   $('.megamenu-content').removeAttr('style');
  // }
});
